class BlocksSlider {
  constructor(selector, options) {
    this.selector = selector;
    this.splide = new Splide(selector, options);
    this.paginationInfoContainer = document.querySelector('.blocks-slider-section .js-pagination-info');

    this.updatePageInfo = this.updatePageInfo.bind(this);
  }

  init() {
    this.splide.mount();
    this.splide.on('moved', this.updatePageInfo);
    this.updatePageInfo();
    this.insertSection();
  }


  updatePageInfo() {
    const totalItems = this.splide.length;
    const itemsPerPage = this.splide.options.perPage;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const currentPage = Math.ceil((this.splide.index + 1) / itemsPerPage);

    this.paginationInfoContainer.textContent = `${currentPage} / ${totalPages}`;
  }

  insertSection() {
    const sectionToMove = document.querySelector(this.selector).parentNode.parentNode.parentNode;
    const insertTarget = document.querySelector(this.selector).parentNode.parentNode.getAttribute('data-insert');
    const insertTargetNode = document.querySelector(insertTarget);
    if (insertTarget !== null) {
      insertTargetNode.parentNode.insertBefore(sectionToMove, insertTargetNode);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const splideBlocksSlider = new BlocksSlider('#slider-blocks-slider-quotes', {
    type: 'loop',
    perPage: 1,
    rewind: true,
    pagination: true,
    autoHeight: true,
    breakpoints: {
      768: {
        perPage: 1,
      },
    }
  });

  splideBlocksSlider.init();
});
